import LookupApi from 'models/location/integrations/lookup_api';
import changeCurrentLocation from 'actions/lib/change_current_location';

export default class OpenLookupApi {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (!this.context.stores.appFeatures.get().isEnabled('integrationsManagement')) {
      this.context.router.navigateHome();
      return;
    }

    changeCurrentLocation(this.context, LookupApi.create());

    if (!this.context.stores.lookupApiConfig.get()) {
      this.context.gateways.customerLookupConfiguration.request();
      this.context.stores.lookupApiConfig.setLoading();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/open_lookup_api.js